const agePopupModal = document.getElementById("age-popup-modal");

if (agePopupModal) {
    $("#age-popup-modal").modal("show");

    $(".js-age-popup-confirm").on("click", function () {
        $(this).addClass("is-loading");

        $.post(
            "/confirm-age-popup",
            {},
            function (response) {
                if (response.status) {
                    $("#age-popup-modal").modal("hide");
                }
            },
            "json"
        );
    });

    $(".js-age-popup-reject").on("click", function () {
        $(this).addClass("is-loading");
    });
}
